export const toitureTranslations = {
  // Hero
  breadcrumb_home: 'Accueil',
  breadcrumb_current: 'Toiture Lévis',
  hero_h1: 'Toiture à Lévis : tous les types, prix et durée de vie',
  hero_subtitle: "Bardeau d'asphalte, tôle, membrane élastomère. Comparez avant la soumission.",
  hero_cta: 'Demander ma soumission gratuite',
  hero_stat_1: '+500 toitures posées',
  hero_stat_2: 'Google',
  hero_stat_3: 'Garantie 10 ans',

  // Intro
  intro_h2: "Choisir la bonne toiture à Lévis, c'est pas un détail",
  intro_text: "Notre climat est dur avec les toits. Cycles gel-dégel, neige lourde, vents du Saint-Laurent. Le matériau choisi aujourd'hui détermine combien de fois on y revient dans les 20 prochaines années. Voici les 4 options que nos partenaires installent à Lévis, avec leurs vrais avantages et leurs vrais inconvénients.",

  // Comparatif Cards
  comparatif_h2: 'Les 4 types de toiture\u0026nbsp;que nos partenaires installent à Lévis',

  card_bardeau_title: "BARDEAU D\u0026rsquo;ASPHALTE",
  card_bardeau_duree: 'Durée : 20–25 ans',
  card_bardeau_prix: "Prix Lévis : 7\u0026nbsp;000\u0026nbsp;$\u0026ndash;12\u0026nbsp;000\u0026nbsp;$ (bungalow)",
  card_bardeau_plus1: 'Abordable, esthétique classique, large choix couleurs',
  card_bardeau_plus2: 'Plusieurs fournisseurs locaux disponibles',
  card_bardeau_minus1: 'Durée moindre, sensible aux grands vents',
  card_bardeau_minus2: 'Doit être changé en entier à la fin de vie',
  card_bardeau_cta: 'En savoir plus',

  card_tole_title: 'TOITURE TÔLE / MÉTAL',
  card_tole_duree: 'Durée : 40–50 ans',
  card_tole_prix: "Prix Lévis : 14\u0026nbsp;000\u0026nbsp;$\u0026ndash;37\u0026nbsp;000\u0026nbsp;$",
  card_tole_plus1: 'Durable, résistant neige/glace, valeur revente',
  card_tole_plus2: "Peut être installé par-dessus l'ancienne toiture",
  card_tole_minus1: 'Investissement initial élevé',
  card_tole_minus2: 'Bruit pluie possible, coût de réparation plus élevé',
  card_tole_cta: 'En savoir plus',

  card_membrane_title: 'MEMBRANE ÉLASTOMÈRE (TOIT PLAT)',
  card_membrane_duree: 'Durée : 25–35 ans',
  card_membrane_prix: "Prix Lévis : 7\u0026nbsp;500\u0026nbsp;$\u0026ndash;35\u0026nbsp;000\u0026nbsp;$",
  card_membrane_plus1: 'Étanchéité parfaite, idéal toit plat',
  card_membrane_plus2: 'Installation souvent 1 seule journée',
  card_membrane_minus1: 'Visuel moins esthétique',
  card_membrane_minus2: 'Requiert spécialiste certifié membrane',
  card_membrane_cta: 'En savoir plus',

  card_blanc_title: 'TOIT BLANC / ÉCOLOGIQUE',
  card_blanc_duree: 'Durée : 25–30 ans',
  card_blanc_prix: "Prix Lévis : 9\u0026nbsp;000\u0026nbsp;$\u0026ndash;15\u0026nbsp;000\u0026nbsp;$",
  card_blanc_plus1: 'Réduit climatisation, écologique',
  card_blanc_plus2: 'Subventions possibles',
  card_blanc_minus1: 'Salissure plus visible',
  card_blanc_minus2: 'Coût supérieur au bardeau standard',
  card_blanc_cta: 'Demander info',

  // Tableau
  tableau_h2: 'Comparatif rapide : quel toit pour votre maison\u0026nbsp;?',
  tableau_note: "Prix indicatifs 2026 pour bungalow 1\u0026nbsp;500\u0026nbsp;pi\u0026sup2;. Soumission précise sur place.",
  tableau_col_type: 'Type',
  tableau_col_duree: 'Durée de vie',
  tableau_col_prix: 'Prix moyen',
  tableau_col_entretien: 'Entretien',
  tableau_col_ideal: 'Idéal pour',
  tableau_bardeau_type: "Bardeau d'asphalte",
  tableau_bardeau_duree: '20–25 ans',
  tableau_bardeau_prix: "7\u0026nbsp;000\u0026nbsp;$\u0026ndash;12\u0026nbsp;000\u0026nbsp;$",
  tableau_bardeau_entretien: 'Inspection + nettoyage',
  tableau_bardeau_ideal: 'Maison standard, budget modéré',
  tableau_tole_type: 'Tôle / Métal',
  tableau_tole_duree: '40–50 ans',
  tableau_tole_prix: "14\u0026nbsp;000\u0026nbsp;$\u0026ndash;37\u0026nbsp;000\u0026nbsp;$",
  tableau_tole_entretien: 'Minimal',
  tableau_tole_ideal: 'Durabilité, revente, maison haut de gamme',
  tableau_membrane_type: 'Membrane élastomère',
  tableau_membrane_duree: '25–35 ans',
  tableau_membrane_prix: "7\u0026nbsp;500\u0026nbsp;$\u0026ndash;35\u0026nbsp;000\u0026nbsp;$",
  tableau_membrane_entretien: 'Inspection bi-annuelle joints',
  tableau_membrane_ideal: 'Toit plat, garage, extension',
  tableau_blanc_type: 'Toit blanc',
  tableau_blanc_duree: '25–30 ans',
  tableau_blanc_prix: "9\u0026nbsp;000\u0026nbsp;$\u0026ndash;15\u0026nbsp;000\u0026nbsp;$",
  tableau_blanc_entretien: 'Nettoyage annuel',
  tableau_blanc_ideal: 'Écologique, réduction énergie',

  // Signes
  signes_h2: "5 signes que votre toiture à Lévis a besoin d\u0026rsquo;être refaite",
  signe_1: 'Bardeaux soulevés, fendus ou manquants après\u0026nbsp;l\u0026rsquo;hiver',
  signe_2: "Granules de bardeau dans les gouttières",
  signe_3: "Taches d\u0026rsquo;eau au plafond ou dans l\u0026rsquo;entretoit",
  signe_4: 'Affaissement visible de la structure',
  signe_5: 'Toiture de plus de 20 ans non inspectée',

  // Pourquoi nous
  pourquoi_h2: 'Pourquoi confier votre toiture à nos couvreurs partenaires',
  pourquoi_1_title: 'Couvreurs certifiés et CCQ',
  pourquoi_1_desc: 'Tous nos couvreurs partenaires détiennent les certifications exigées au Québec. Pas de bricolage.',
  pourquoi_2_title: 'Garantie écrite 10 ans signée',
  pourquoi_2_desc: "Un contrat avec votre nom dessus. Main-d'œuvre et matériaux. On assume.",
  pourquoi_3_title: 'Soumission détaillée en 2h',
  pourquoi_3_desc: 'Photos, options, délais, prix par poste. Pas de chiffres en l\u0026rsquo;air.',
  pourquoi_4_title: 'Service hiver pour urgences',
  pourquoi_4_desc: "Fuite, bardeau soulevé, glace — on intervient même quand le thermomètre descend.",

  // Témoignage
  temoin_text: "On avait une toiture de 23 ans qui commençait à couler à plusieurs endroits. J\u0026rsquo;avais peur de me faire fourrer par un couvreur qui me vendrait n\u0026rsquo;importe quoi. Un couvreur partenaire de Couvreur-Lévis.com est venu inspecter, m\u0026rsquo;a montré les photos de chaque problème, et m\u0026rsquo;a expliqué pourquoi la tôle était le meilleur choix pour ma maison exposée aux vents du Saint-Laurent. Ils ont terminé en 3 jours, ont nettoyé derrière eux comme des pros, et la toiture est magnifique. Je recommande à tous mes voisins de Saint-Nicolas. C\u0026rsquo;est la première fois que je paye pour des travaux et que je suis 100% satisfait du début à la fin.",
  temoin_name: 'Jean-François P.',
  temoin_location: 'Saint-Nicolas',
  temoin_project: 'Toiture tôle, 2\u0026nbsp;800\u0026nbsp;pi\u0026sup2;',
  temoin_cta: 'Demander une soumission',

  // FAQ
  faq_h2: 'Questions fréquentes sur la toiture à Lévis',
  faq_q1: 'Quelle est la meilleure toiture pour le climat de Lévis ?',
  faq_a1: "Pour la majorité des maisons à Lévis, le bardeau d'asphalte de qualité reste le choix #1 parce qu'il est abordable et performant. Mais si votre maison est exposée aux vents du fleuve ou si vous prévoyez de rester longtemps, la tôle métal vaut l'investissement — elle dure 2x plus longtemps. Pour les toits plats, la membrane élastomère est sans conteste la meilleure option.",
  faq_q2: "Combien de temps dure l'installation d'une nouvelle toiture ?",
  faq_a2: "Un bungalow standard en bardeau d'asphalte : 1 à 2 jours. Une maison de 2 étages ou une toiture complexe : 2 à 4 jours. La tôle métal prend un peu plus de temps (3 à 5 jours) car la coupe doit être précise. La membrane élastomère sur toit plat : souvent 1 journée seulement.",
  faq_q3: "Mon assurance couvre-t-elle le remplacement de toiture ?",
  faq_a3: "Ça dépend de la cause. Dommage par une tempête, grêle ou vent fort : oui, généralement couvert. Usure normale liée à l'âge : non, c'est à votre charge. On peut vous aider à documenter les dommages pour votre assureur avec un rapport photo détaillé et une attestation de notre inspecteur certifié.",
  faq_q4: "Existe-t-il des subventions pour rénovation toiture au Québec ?",
  faq_a4: "Oui, plusieurs programmes existent. Le Programme RénoVert du gouvernement du Québec offre un crédit d'impôt pour certains travaux écoénergétiques. La Ville de Lévis et la MRC peuvent aussi avoir des incitatifs pour les toitures blanches ou réflectives. On vous guide dans les démarches au moment de la soumission.",
  faq_q5: "Faut-il enlever l'ancienne toiture avant la nouvelle ?",
  faq_a5: "Pour le bardeau d'asphalte : on recommande l'enlèvement complet pour inspecter le pontage. Ça coûte un peu plus, mais ça évite les mauvaises surprises. Pour la tôle métal : on peut parfois installer par-dessus si la structure le permet. Pour la membrane élastomère : l'ancienne surface doit être propre et saine. On évalue ça lors de l'inspection gratuite.",

  // CTA Final
  cta_h2: 'Votre soumission toiture à Lévis, livrée en 2h',
  cta_subtitle: 'Inspection gratuite, prix détaillé par matériau, zéro engagement.',
  cta_button: 'Obtenir ma soumission',
  cta_phone: '418-476-9950',

  // Formulaire
  form_h2: 'Demandez votre soumission gratuite',
  form_subtitle: 'Remplissez le formulaire — on vous rappelle en 2h ouvrables.',
  form_success: 'Soumission envoyée !',
  form_success_sub: 'On vous rappelle dans les 2 prochaines heures ouvrables. Merci de nous faire confiance.',
  form_name_label: 'Nom complet',
  form_name_placeholder: 'Votre nom',
  form_phone_label: 'Téléphone',
  form_phone_placeholder: '418-476-9950',
  form_email_label: 'Courriel',
  form_email_placeholder: 'votre@email.com',
  form_service_label: 'Type de service',
  form_service_select: 'Sélectionnez un service',
  form_message_label: 'Description du projet',
  form_message_placeholder: 'Décrivez votre toiture, les problèmes observés, la superficie approximative...',
  form_char_count: '/500',

  // Header
  nav_home: 'Accueil',
  nav_services: 'Services',
  nav_about: 'À propos',
  nav_quote: 'Soumission',
  phone_number: '418-476-9950',
  cta_quote: 'Soumission gratuite',

  // Footer
  footer_brand: 'Couvreur-Lévis.com',
  footer_address: 'Lévis, QC, Canada',
  footer_email: 'contact@couvreur-levis.com',
  footer_services_title: 'Services',
  footer_link_refaction: 'Réfection toiture',
  footer_link_repair: 'Réparation',
  footer_link_flat: 'Toit plat',
  footer_link_metal: 'Tôle et métal',
  footer_link_inspection: 'Inspection',
  footer_links_title: 'Liens',
  footer_link_about: 'À propos',
  footer_link_quote: 'Soumission',
  footer_link_legal: 'Mentions légales',
  footer_link_privacy: 'Politique de confidentialité',
  footer_link_blog: 'Blog',
  footer_copyright: '© 2026 Couvreur-Lévis.com. Tous droits réservés.',
  footer_hours_title: 'Heures',
  footer_hours_week: 'Lun–Ven : 7h00 – 18h00',
  footer_hours_weekend: 'Sam–Dim : 8h00 – 16h00',
};

export default toitureTranslations;